import {Injectable, Injector} from "@angular/core";
import {SupplierData} from "./supplier.data";
import {EntityModel} from "@fedeltapointofsale/data-client";

@Injectable()
export class SupplierEntityModel extends EntityModel<SupplierData> {

    constructor(injector: Injector) {
        super(injector, SupplierData);
    }
}
